import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14",
  stroke: "white"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.24805 10.7339C3.32848 11.5517 3.51026 12.1021 3.92108 12.513C4.65795 13.2499 5.84391 13.2499 8.21585 13.2499C10.5878 13.2499 11.7738 13.2499 12.5106 12.513C13.2475 11.7761 13.2475 10.59 13.2475 8.21801C13.2475 5.84598 13.2475 4.65996 12.5106 3.92306C12.0998 3.51222 11.5494 3.33044 10.7317 3.25",
      fill: "none",
      "stroke-width": "1.2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M0.748047 5.74993C0.748047 3.39294 0.748047 2.21445 1.48024 1.48222C2.21243 0.75 3.39088 0.75 5.74777 0.75C8.10466 0.75 9.2831 0.75 10.0153 1.48222C10.7475 2.21445 10.7475 3.39294 10.7475 5.74993C10.7475 8.10692 10.7475 9.28541 10.0153 10.0176C9.2831 10.7499 8.10466 10.7499 5.74777 10.7499C3.39088 10.7499 2.21243 10.7499 1.48024 10.0176C0.748047 9.28541 0.748047 8.10692 0.748047 5.74993Z",
      fill: "none",
      "stroke-width": "1.2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M0.748047 6.44907C1.13491 6.3999 1.52603 6.37561 1.9178 6.37646C3.57517 6.34581 5.19195 6.7977 6.47965 7.65149C7.67391 8.44333 8.51307 9.53309 8.87259 10.7499",
      fill: "none",
      "stroke-width": "1.2",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.62293 3.875H7.62854",
      fill: "none",
      "stroke-width": "2.14278",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }